/**
 * Created by ronmarsiano on 06/02/2018.
 */
mainApp.directive('proxyFileConfig', function() {
    return {
        templateUrl: '/public/directives/proxyFileConfig.html',
        scope: {
            proxyFileConfigProperties: '='
        },
        controller:  ['$scope', '$timeout', function($scope, $timeout) {
            var URL_ERROR_MESSAGE = 'Required';

            var hasChanges = function () {
                if($scope.proxyFileConfigProperties && $scope.proxyFileConfigProperties.entity &&
                    $scope.proxyFileConfigProperties.entity.proxyConfigurationFile){
                    if(isValid()){

                        // if no orig - this is new config
                        if (!$scope.proxyFileConfigProperties.orig.proxyConfigurationFile) {
                            return true;
                        }
                        return !angular.equals($scope.proxyFileConfigProperties.entity.proxyConfigurationFile.proxyConfigEnabled,$scope.proxyFileConfigProperties.orig.proxyConfigurationFile.proxyConfigEnabled) ||
                            !angular.equals($scope.proxyFileConfigProperties.entity.proxyConfigurationFile.pacFileUrl,$scope.proxyFileConfigProperties.orig.proxyConfigurationFile.pacFileUrl);
                    }
                    else{
                        return false;
                    }
                }
            };

            function isValid() {
                if($scope.proxyFileConfigProperties.entity.proxyConfigurationFile.proxyConfigEnabled==true && (!$scope.proxyFileConfigProperties.entity.proxyConfigurationFile.pacFileUrl ||  $scope.proxyFileConfigProperties.entity.proxyConfigurationFile.pacFileUrl.length==0)){
                    $scope.$root.errors['proxyFileUrlError'] = URL_ERROR_MESSAGE;
                    return false;
                }
                else{
                    delete $scope.$root.errors['proxyFileUrlError'];
                    return true;
                }
            }


            function init() {
                if($scope.proxyFileConfigProperties && $scope.proxyFileConfigProperties.entity){
                    $scope.proxyFileConfigProperties.hasChanges = hasChanges;
                }
                else{
                    $timeout(function () {
                        init();
                    },100);
                }
            }

            /**
             * we would like the init function to be invoked only after all
             * digest and loading of the directive are done
             */
            $timeout(function () {
                init();
            },1);


        }]
    };
});